import { render, staticRenderFns } from "./navMenu.vue?vue&type=template&id=aa05a660&scoped=true"
import script from "./navMenu.vue?vue&type=script&lang=js"
export * from "./navMenu.vue?vue&type=script&lang=js"
import style0 from "./navMenu.vue?vue&type=style&index=0&id=aa05a660&prod&scoped=true&lang=less"
import style1 from "./navMenu.vue?vue&type=style&index=1&id=aa05a660&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa05a660",
  null
  
)

export default component.exports